<template>
  <div class="spinner-container">
    <div class="spinner spinner-grow" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'Spinner',
        computed: {
            locale() {
                return this.$i18n.locale
            },

        },
    }
</script>

<style lang="scss">
  @import "../../../sass/variables";

  .spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .spinner {
      width: 3rem; height: 3rem;
      color: $color-primary;
    }
  }
</style>